import * as React from "react";
import { page } from "../../components/Auth/Page";

export const RefreshProfilePage = page(React.lazy(() => import("./containers/RefreshProfilePage")));
